import { z } from 'zod/v4';

export const LoginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(6),
  ephemeral: z.boolean().optional(),
});

export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const RegisterRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(6),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  referralCode: z.string().optional(),
  ephemeral: z.boolean().optional(),
});

export type RegisterRequest = z.infer<typeof RegisterRequestSchema>;

export const TokenResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  user: z.any().optional(),
  requires2FA: z.boolean().optional(),
  tempToken: z.string().optional(),
}).passthrough();

export type TokenResponse = z.infer<typeof TokenResponseSchema>;

export function readPlatformRoleFromUser(user: unknown): string | undefined {
  if (!user || typeof user !== 'object') return undefined;
  const role = (user as Record<string, unknown>).role;
  return typeof role === 'string' ? role : undefined;
}

export function readLocaleFromAuthUser(user: unknown): string | undefined {
  if (!user || typeof user !== 'object') return undefined;
  const profile = (user as Record<string, unknown>).profile;
  if (!profile || typeof profile !== 'object') return undefined;
  const locale = (profile as Record<string, unknown>).locale;
  return typeof locale === 'string' ? locale : undefined;
}
